import { isPlatformBrowser } from '@angular/common';
import {
  ErrorHandler,
  NgModule,
  PLATFORM_ID,
  inject,
  provideAppInitializer,
} from '@angular/core';
import * as Sentry from '@sentry/angular';

import { filter, first } from 'rxjs';

import { ConfigurationService, IEnvironmentConfig } from '@sondermind/configuration';
import { DatadogLoggingModule } from '@sondermind/datadog-logging';
import { SentryClient } from '@sondermind/sentry-client';

import { CURRENT_COMMIT_HASH, currentCommitHash } from './current-commit-sha';

function initLoggingServices(configService: ConfigurationService, commitHash: string, platformId): () => Promise<void> {
  return () => new Promise((resolve) => {
    if (!isPlatformBrowser(platformId)) {
      resolve();
    }
    configService.configSubj
      .pipe(
        filter((e) => !!e && Object.keys(e).length !== 0),
        first()
      ).subscribe((config: IEnvironmentConfig) => {
        SentryClient.initialize(config, commitHash);
        DatadogLoggingModule.bootstrap(config);
        resolve();
      });
  });
}

@NgModule({
  providers: [
    provideAppInitializer(() => {
      const initializerFn = (initLoggingServices)(inject(ConfigurationService), inject(CURRENT_COMMIT_HASH), inject(PLATFORM_ID));
      return initializerFn();
    }),
    {
      provide: CURRENT_COMMIT_HASH,
      useValue: currentCommitHash
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    }
  ]
})
export class LoggingInitModule { }
